import React from 'react';
import ReactDOM from 'react-dom/client';
import 'flag-icons/css/flag-icons.min.css';
import App from './App';
import './index.css';

// Capturer `beforeinstallprompt` le plus tôt possible : il peut se déclencher
// avant le montage de React. On le met en tampon global (lu par usePwaInstall)
// et on supprime la mini-bannière native du navigateur.
if (typeof window !== 'undefined') {
  window.__geInstallPrompt = window.__geInstallPrompt || null;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__geInstallPrompt = e;
  });
  window.addEventListener('appinstalled', () => { window.__geInstallPrompt = null; });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Le service worker (cache-first sur les assets) n'a de sens qu'en PRODUCTION,
// où Vite émet des noms de fichiers hachés donc immuables. En dev, Vite sert des
// modules mutables à URL stable : un SW cache-first renvoie du JS périmé → page
// blanche jusqu'au rechargement forcé (Ctrl+Shift+R). On ne l'enregistre donc
// qu'en build de prod, et en dev on désinscrit tout SW résiduel + purge son
// cache pour auto-réparer les navigateurs déjà affectés.
if (import.meta.env.PROD) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('[SW] Registration failed:', err);
      });
    });
  }
} else if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((regs) => Promise.all(regs.map((reg) => reg.unregister())))
    .catch(() => {});
  if (typeof caches !== 'undefined') {
    caches.keys()
      .then((keys) =>
        Promise.all(
          keys
            .filter((k) => k.startsWith('ge-shell-'))
            .map((k) => caches.delete(k))
        )
      )
      .catch(() => {});
  }
}
